import {
  PRINT_PDF_OWN,
  PRINT_PDF_OWN_TA,
  PRINT_PDF_PEER,
  PRINT_PDF_EVU_ADMIN,
  PRINT_PDF_REPORT,
  PRINT_PDF_REPORT_TA
} from "./constants";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { documentLogo } from "../../components/Results/documentLogo";
import { indexText } from "../../components/Results/indexText";
import ReactDOMServer from "react-dom/server";

const pdf = new jsPDF();

export function printPDFReport_TARequest() {
  return {
    type: PRINT_PDF_REPORT_TA,
    payload: {}
  };
}

export function printPDFOwnRequest() {
  return {
    type: PRINT_PDF_OWN,
    payload: {}
  };
}

export function printPDFOwn(chart, language) {
  const pdf = new jsPDF();

  return dispatch => {
    dispatch(printPDFOwnRequest());
    let imgData;
    let html;

    pdf.addImage(documentLogo, "PNG", 90, 2, 25, 25);

    html = ReactDOMServer.renderToString(indexText[language]);

    var options = { pagesplit: true, width: 180 };
    let text;
    pdf.fromHTML(html, 10, 38, options);

    language === "en"
      ? (text = "Institute of leadership dynamics evaluation report")
      : (text = "Institute of leadership dynamics evalueringsrapport");
    pdf.text(text, 40, 40);

    html2canvas(chart).then(canvas => {
      imgData = canvas.toDataURL("image/png");

      let text;
      if (language === "en") {
        text = "Results of evaluation";
      } else {
        text = "Resultater af evaluering";
      }
      pdf.addPage("a4");
      pdf.text(text, 80, 7);
      pdf.addImage(imgData, "png", 20, 20, 175, 100);

      options = {
        pagesplit: true,
        width: 180
      };

      pdf.save("result.pdf");
    });
  };
}

export function printPDFPeerRequest() {
  return {
    type: PRINT_PDF_PEER,
    payload: {}
  };
}

export function printPDFPeer(
  chart,
  gap,
  language,
  peer1Name,
  peer2Name,
  peer3Name,
  setHighLight
) {

  return dispatch => {
    dispatch(printPDFOwnRequest());
    const pdf = new jsPDF();
    let imgData;
    let html = '';
    let text = '';

    pdf.addImage(documentLogo, "PNG", 90, 2, 25, 25);
    language === "en"
      ? (text = "Institute of leadership dynamics evaluation report")
      : (text = "Institute of leadership dynamics evalueringsrapport");
    pdf.text(text, 40, 40);
    html = ReactDOMServer.renderToString(indexText[language]);

    var options = { pagesplit: true, width: 180 };
    pdf.fromHTML(html, 10, 38, options);

    html2canvas(chart).then(canvas => {
      imgData = canvas.toDataURL("image/png");
      if (language === "en") {
        text = "Results of evaluation";
      } else {
        text = "Resultater af evaluering";
      }
      pdf.addPage("a4");
      pdf.text(text, 80, 7);
      pdf.text(
        language === "en" ? "All highlighted" : "Alle fremhævet",
        90,
        15
      );

      pdf.addImage(imgData, "png", 20, 20, 175, 100);

      setHighLight("peer1");

      html2canvas(chart).then(canvas => {
        imgData = canvas.toDataURL("image/png");
        pdf.addPage("a4");
        pdf.text(peer1Name, 90, 10);
        pdf.addImage(imgData, "png", 20, 20, 175, 100);

        if (peer2Name) {
          setHighLight("peer2");
          html2canvas(chart).then(canvas => {
            imgData = canvas.toDataURL("image/png");
            pdf.addPage("a4");
            pdf.text(peer2Name, 90, 10);
            pdf.addImage(imgData, "png", 20, 20, 175, 100);

            if (peer3Name) {
              setHighLight("peer3");
              html2canvas(chart).then(canvas => {
                imgData = canvas.toDataURL("image/png");
                pdf.addPage("a4");
                pdf.text(peer3Name, 90, 10);
                pdf.addImage(imgData, "png", 20, 20, 175, 100);

                pdf.addPage("a4");

                html2canvas(gap).then(canvas => {
                  imgData = canvas.toDataURL("image/png");
                  pdf.addImage(imgData, "png", -92, -35, 330, 330);

                  pdf.save("result.pdf");
                });
              });
            } else {
              pdf.addPage("a4");

              html2canvas(gap).then(canvas => {
                imgData = canvas.toDataURL("image/png");
                pdf.addImage(imgData, "png", -92, -35, 390, 330);

                options = {
                  pagesplit: true,
                  width: 180
                };

                pdf.save("result.pdf");
              });
            }
          });
        } else {
          pdf.addPage("a4");

          html2canvas(gap).then(canvas => {
            imgData = canvas.toDataURL("image/png");
            pdf.addImage(imgData, "png", -78, -45, 350, 350);

            options = {
              pagesplit: true,
              width: 180
            };

            pdf.save("result.pdf");
          });
        }
      });
    });
  };
}

export function printPDFEvuAdminRequest() {
  return {
    type: PRINT_PDF_EVU_ADMIN,
    payload: {}
  };
}

export function printPDFEvuAdmin(id, peer2, chart, gap, language) {
  return dispatch => {
    dispatch(printPDFEvuAdminRequest);

    const pdf = new jsPDF();

    let html;
    html = ReactDOMServer.renderToString(indexText[language]);
    var options = { pagesplit: true, width: 180 };
    pdf.addImage(documentLogo, "PNG", 90, 4, 25, 25);

    pdf.fromHTML(html, 10, 38, options);

    pdf.addPage("a4");
    html2canvas(chart).then(canvas => {
      let imgData = canvas.toDataURL("image/png");
      pdf.addImage(imgData, "png", -20, 10, 250, 100);
      if (peer2) {
        pdf.addPage("a4");

        html2canvas(gap).then(canvas => {
          imgData = canvas.toDataURL("image/png");
          pdf.addImage(imgData, "png", -88, -55, 380, 360);
          pdf.save("result.pdf");
        });
      } else {
        pdf.save("result.pdf");
      }
    });
  };
}

export function printPDFOwnTaRequest() {
  return {
    type: PRINT_PDF_OWN_TA,
    payload: {}
  };
}

export function printPDFOwnTa(chart, language, drivers) {
  const pdf = new jsPDF();

  return dispatch => {
    dispatch(printPDFOwnTaRequest());
    let imgData;
    let html;

    pdf.addImage(documentLogo, "PNG", 90, 2, 25, 25);
    html = ReactDOMServer.renderToString(indexText[language]);

    var options = { pagesplit: true, width: 180 };
    let text;
    pdf.fromHTML(html, 10, 38, options);

    language === "en"
      ? (text = "Institute of leadership dynamics evaluation report")
      : (text = "Institute of leadership dynamics evalueringsrapport");
    pdf.text(text, 40, 40);

    html2canvas(chart).then(canvas => {
      imgData = canvas.toDataURL("image/png");

      let text;
      if (language === "en") {
        text = "Results of evaluation";
      } else {
        text = "Resultater af evaluering";
      }
      pdf.addPage("a4");
      pdf.text(text, 80, 7);
      pdf.addImage(imgData, "png", 20, 20, 175, 200);

      options = {
        pagesplit: true,
        width: 180
      };

      drivers
        ? html2canvas(drivers).then(canvas => {
            imgData = canvas.toDataURL("image/png");

            text = "Drivers";
            pdf.addPage("a4");
            pdf.text(text, 100, 7);
            pdf.addImage(imgData, "png", 20, 20, 175, 100);
            pdf.save("result.pdf");
          })
        : pdf.save("result.pdf");
    });
  };
}

export function printPDFAdminReportRequest() {
  return {
    type: PRINT_PDF_REPORT,
    payload: {}
  };
}

export function printPDFAdminReport(
  chart,
  highlight,
  setHighLight,
  progressBar,
  language,
  mapResults,
  categories,
  qdata,
  item,

  index
) {
  var text  = ''
  let i;
  let procent;

  if (i === 0) {
    pdf.addImage(documentLogo, "PNG", 80, 50, 50, 50);
    pdf.setFontSize(35);

    text = language === "en" ? "Evaluation report" : "Evalueringsrapport";

    pdf.text(55, 150, pdf.splitTextToSize(text, 180));

    pdf.setFontSize(10);
    text = "INSTITUTE OF LEADERSHIP DINAMICS";
    pdf.text(72, 285, pdf.splitTextToSize(text, 180));

    text = "https://leadershipdynamic.net";
    pdf.text(79, 290, pdf.splitTextToSize(text, 180));

    pdf.addPage("a4");
  }

  chart.setAttribute("data", mapResults(item.id, categories[i]));
  html2canvas(chart).then(canvas => {
    const imgData = canvas.toDataURL("image/png");

    let text = categories[i];
    pdf.text(10, 20, pdf.splitTextToSize(text, 180));

    let v = 170;
    mapResults(item.id, categories[i]).forEach(element => {
      let text = ''
      pdf.setFontStyle("bold");
      text = element.key;
      pdf.text(10, v, pdf.splitTextToSize(text, 180));
      pdf.setFontStyle("none");

      if (!element.peer1) {
        text =
          language === "en"
            ? "Own: " + element.own + "   " + item.peer1N + ": " + element.peer1
            : "Egen: " +
              element.own +
              "   " +
              item.peer1N +
              ": " +
              element.peer1;

        if (!element.peer2) {
          text =
            language === "en"
              ? "Own: " +
                element.own +
                "   " +
                item.peer1N +
                ": " +
                element.peer1 +
                "   " +
                item.peer2N +
                ": " +
                element.peer2
              : "Egen: " +
                element.own +
                "   " +
                item.peer1N +
                ": " +
                element.peer1 +
                "   " +
                item.peer2N +
                ": " +
                element.peer2;

          if (!element.peer3) {
            text =
              language === "en"
                ? "Own: " +
                  element.own +
                  "   " +
                  item.peer1N +
                  ": " +
                  element.peer1 +
                  "   " +
                  item.peer2N +
                  ": " +
                  element.peer2 +
                  "   " +
                  item.peer3N +
                  ": " +
                  element.peer3
                : "Egen: " +
                  element.own +
                  "   " +
                  item.peer1N +
                  ": " +
                  element.peer1 +
                  "   " +
                  item.peer2N +
                  ": " +
                  element.peer2 +
                  "   " +
                  item.peer3N +
                  ": " +
                  element.peer3;
          }
        }
      } else {
        text =
          language === "en" ? "Own: " + element.own : "Egen: " + element.own;
      }

      pdf.text(10, (v += 10), pdf.splitTextToSize(text, 180));

      v += 10;
    });

    pdf.addImage(imgData, "png", 0, 30, 200, 80);

    if (i !== 11) {
      i++;
      setHighLight(categories[i]);

      procent += 9.5;

      progressBar.innerHTML = `<div class="ant-progress-bg" style="width: ${procent}%; height: 8px;">`;

      printPDFAdminReport(
        chart,
        progressBar,

        language,

        mapResults,
        categories,

        mapResults(item.id, categories[i]),
        item,
        index
      );
      pdf.addPage("a4");
    } else {
      pdf.save("result.pdf");
      progressBar.innerHTML = `<div class="ant-progress-bg" style="width: 0%; height: 8px;">`;
    }
  });
}



// WEBPACK FOOTER //
// ./src/modules/pdf/actions.js